<template>
  <div>
    <div class="hvh-flex font-md no-wrap mb-1">
      <span class="underline clickable" @click="goTo({ name: 'cohorts' })">Scipher Search</span>
      <span class="mx-2">></span>
      <span>{{ trimString(60, value.name) }}</span>
    </div>
    <div class="hvh-flex space-between mb-3">
      <div class="hvh-flex grow-1 mr-1">
        <div class="analysis-icon p-2">
          <IconAnalysis />
        </div>
        <div class="grow-1 ml-2 mr-1">
          <CohortHeaderEdit :value="value" @input="$emit('input', $event)" />

          <div class="hvh-flex mt-3 no-wrap">
            <div>
              <p class="mb-0">VERSION</p>
              <p class="mb-0">LAST UPDATED</p>
            </div>
            <div class="ml-3">
              <a @click="showAllVersions = true">{{ versionIndex + 1 }} of {{ allVersions.length }}</a>
              <p class="mb-0">{{ browserDateTime(value.lastUpdatedOn) }}</p>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="hvh-flex align-baseline h-100">
          <div class="hvh-flex column space-between text-right h-100">
            <div>
              <p class="cohort-title bold mb-1">{{ customNumberFormat((value.cohortStatistic || {}).totalCount) }} Patients</p>
              <p class="mb-1">{{ value.patientDatasource }}</p>
              <div class="additional-heading">
                <CohortVerifiedHeading :value="value.cohortVerified" v-if="value.cohortVerified" />
                <CohortPrivateHeading v-if="value.isPrivate" />
              </div>
            </div>
            <div class="text-right">
              <p class="mb-0">{{ value.createdBy }}</p>
            </div>
          </div>
          <div class="hvh-flex column align-end space-between h-100 ml-3">
            <div class="hvh-flex column align-end">
              <CohortListItemMenu
                :item="value"
                @hide-cohort="$emit('hide-cohort', $event)"
                @clinically-verify="$emit('clinically-verify', $event)"
                @ask-clinically-verify="$emit('ask-clinically-verify', $event)"
                @archive="$emit('archive')"
                @archive-all-versions="$emit('archive-all-versions')"
                @copy-url="$emit('copy-url')"
                @new-analysis="$emit('new-analysis')"
              />
              <PinIcon class="mt-2" :value="value.isPinned" @input="$emit('pin-cohort', !value.isPinned)" />
            </div>
            <div class="pb-1">
              <FlaskIcon />
            </div>
          </div>
        </div>
      </div>
    </div>

    <hvh-modal :value="true" title="Cohort versions" max-width="700px" @input="showAllVersions = false" v-if="showAllVersions">
      <template v-slot>
        <v-data-table :headers="allVersionsHeaders" :items="filteredVersions" class="hvh-table elevation-1" hide-default-header hide-default-footer>
          <template v-slot:items="{ item }">
            <tr :class="{ disabled: item.disabled, clickable: !item.disabled }" @click="(showAllVersions = false), $router.push({ name: 'cohort', params: { id: item.id } })">
              <td>
                <span :class="{ 'hvh-strong': isCurrentVersion(item) }">{{ item.index + 1 }}</span>
              </td>
              <td>
                <span :class="{ 'hvh-strong': isCurrentVersion(item) }">{{ browserDate(item.creationDate) }}</span>
              </td>
              <td>
                <span :class="{ 'hvh-strong': isCurrentVersion(item) }">{{ customNumberFormat(item.totalPatients) }}</span>
              </td>
              <td>
                <span :class="{ 'hvh-strong': isCurrentVersion(item) }">{{ item.reason }}</span>
              </td>
            </tr>
          </template>
        </v-data-table>
        <h5 class="disabled" v-if="filteredVersions.length < allVersions.length">Some versions may be hidden due to cohort permission settings.</h5>
      </template>
    </hvh-modal>
  </div>
</template>

<script>
import { customNumberFormat, trimString } from '../../../libraries/common';
import IconAnalysis from '../../common/icon/IconAnalysis.vue';
import CohortHeaderEdit from './headerEdit/CohortHeaderEdit.vue';
import CohortListItemMenu from './CohortListItemMenu.vue';
import CohortPrivateHeading from './CohortPrivateHeading.vue';
import CohortVerifiedHeading from './CohortVerifiedHeading.vue';
import FlaskIcon from './icons/FlaskIcon.vue';
import PinIcon from './icons/PinIcon.vue';
export default {
  export: false,
  components: { IconAnalysis, PinIcon, CohortListItemMenu, FlaskIcon, CohortHeaderEdit, CohortVerifiedHeading, CohortPrivateHeading },
  props: ['value', 'options'],
  data() {
    return {
      allVersionsHeaders: [
        { text: 'Version', class: ['hvh-table-header'], sortable: false },
        { text: 'Last updated', class: ['hvh-table-header'], sortable: false },
        { text: 'Patients', class: ['hvh-table-header'], sortable: false },
        { text: 'Reason', class: ['hvh-table-header'], sortable: false },
      ],
      showAllVersions: false,
      titleForEdit: null,
    };
  },
  computed: {
    allVersions() {
      return this.options?.allVersions || [];
    },
    filteredVersions() {
      return this.allVersions.filter((f) => f.canSee).reverse();
    },
    versionIndex() {
      return this.allVersions.find((f) => f.id === this.value.id)?.index;
    },
  },
  methods: {
    isCurrentVersion(item) {
      return item.id === this.value.id;
    },
    customNumberFormat,
    trimString,
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisCohortHeader'] = this;
  },
};
</script>

<style lang="scss" scoped>
.cohort-title {
  font-size: 24px;
}

.analysis-icon {
  min-width: 46px;
  height: 46px;
  background-color: #d2ecf3;
  border-radius: 8px;
}

.additional-heading {
  border-radius: 5px;
  overflow: hidden;
}
</style>